import React from 'react';

import { PageTitle } from '../../../components';
import { ScheduleEvent } from '../../../sections';



const ScheduleEventPage = () => {

  return (
    <>

      {/* Page Title */}
      <PageTitle title={'Schedule Events'} page={'Schedule Events'} />

      {/* Schedule event section */}
      <ScheduleEvent />

    </>
  );
};

export default ScheduleEventPage;